import { FC } from 'react';
import { VStack } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import { Gender } from 'features/Onboarding/legacy/types';
import { GENDER_OPTIONS } from 'features/Onboarding/modules/Identity/libs/constants';

import locales from './locales';
import { EditPersonalNameFieldsProps } from './types';

const EditPersonalNameFields: FC<EditPersonalNameFieldsProps> = ({
  firstName,
  gender,
  lastName,
  onFirstNameChange,
  onGenderChange,
  onLastNameChange,
}) => (
  <VStack alignItems="stretch" spacing="space-24">
    <Form.Field label={locales.legalTitleLabel}>
      <Form.Radio.Group
        alignSelf="flex-start"
        direction="row"
        name="radio-group"
        onChange={(value) => onGenderChange(value as Gender)}
        value={gender ?? undefined}
        variant="outline"
      >
        {GENDER_OPTIONS.map((option) => (
          <Form.Radio key={option.value} value={option.value}>
            <Form.Radio.Title>{option.abbreviatedLabel}</Form.Radio.Title>
          </Form.Radio>
        ))}
      </Form.Radio.Group>
    </Form.Field>
    <Form.Field label={locales.firstNameLabel}>
      <Form.Input
        onChange={(event) => onFirstNameChange(event.target.value)}
        required
        value={firstName}
      />
    </Form.Field>
    <Form.Field label={locales.lastNameLabel}>
      <Form.Input
        onChange={(event) => onLastNameChange(event.target.value)}
        required
        value={lastName}
      />
    </Form.Field>
  </VStack>
);

export default EditPersonalNameFields;
